import { render, staticRenderFns } from "./CollectionStyles.vue?vue&type=template&id=0cc8d21b&name=collection-styles&"
import script from "./CollectionStyles.vue?vue&type=script&lang=js&"
export * from "./CollectionStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports